module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "ls-modal",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "ls-lg-margin-bottom",
    class: _vm.large ? 'ls-modal-large' : 'ls-modal-box',
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('modalLoader'), _vm._v(" "), _vm._t("content")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ebd2cb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/shareds/modal/Modal.vue
// module id = 725
// module chunks = 1